export enum TabsValue {
  CONVERSATIONS = 'conversations',
  RECRUITMENT = 'recruitment',
  OTHER = 'other',
  CAMPAIGNS_NEEDS_REVIEW = 'campaigns_needs_review'
}

export const labelByValue = {
  [TabsValue.CONVERSATIONS]: 'Conversations',
  [TabsValue.RECRUITMENT]: 'Campaigns',
  [TabsValue.OTHER]: 'Other',
  [TabsValue.CAMPAIGNS_NEEDS_REVIEW]: 'Needs review'
};
